import { render, staticRenderFns } from "./VNotificationItem.vue?vue&type=template&id=2f046b39&"
import script from "./VNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./VNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./VNotificationItem.vue?vue&type=style&index=0&id=2f046b39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports